initNavigation(
    '.btn-next-prev',
    'data-stage',
    '#acept-terms',
    '.error-term',
    'valide-terms',
    '#cart-nome',
    '.error-name',
    '#cart-phone',
    '.error-phone',
    'valide-required'
);

function initNavigation(
    btnsNav,
    dataStage,
    checkTerm,
    msgRequiredTerm,
    btnRequiredTerms,
    inputRequiredName,
    msgRequiredName,
    inputRequiredPhone,
    msgRequiredPhone,
    btnRequiredInput
) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);
    const events = ['keyup', 'change'];

    navegation();
    select(checkTerm)?.addEventListener('change', valideTerms);
    events.forEach(evt => select(inputRequiredName)?.addEventListener(evt, () => validateInputRequired()))
    events.forEach(evt => select(inputRequiredPhone)?.addEventListener(evt, () => validateInputRequired()));

    select(inputRequiredPhone).addEventListener('keyup', ()=> selectAll('.required-field').forEach(required => required.classList.add('d-none')) );

    function navegation() {
        selectAll(btnsNav)?.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                if (btn.classList.contains(btnRequiredTerms)) {
                    valideTerms();
                } else if (btn.classList.contains(btnRequiredInput)) {
                    validateInputRequired();
                } else {
                    activeStageNav(btn);
                }
            })
        })
    }

    function getStage(btn) {
        return `.body-${btn.getAttribute(dataStage)}`;
    }

    function activeStageNav(btn) {
        selectAll(btnsNav).forEach(button => select(getStage(button))?.classList.add('d-none'));

        setTimeout(() => {
            select(getStage(btn)).classList.remove('d-none')
        }, 100);
    }

    function valideTerms() {
        if (select(checkTerm).checked) {
            select(msgRequiredTerm).classList.add('d-none');
            select(`#${btnRequiredTerms}`).classList.remove('valide-terms');
        } else {
            select(msgRequiredTerm).classList.remove('d-none');
            select(`#${btnRequiredTerms}`).classList.add('valide-terms');
        }
    }

    function validateInputRequired() {

        let phoneLength = select(inputRequiredPhone).value.split("(").join("").split(")").join("").split(" ").join("").split("-").join("").length;

        if (phoneLength >= 10 && (select(inputRequiredName).value.length > 2)) {
            select(`#finalizarcompra_step1`).removeAttribute('disabled');
            select(`#finalizarcompra_step1`).classList.remove('disabled');
            select(`#finalizarcompra_step1`).classList.remove(btnRequiredInput);
            select(msgRequiredPhone)?.classList.add('d-none');
            select(msgRequiredName)?.classList.add('d-none');

        } else {
            if (phoneLength >= 10) {
                select(msgRequiredPhone)?.classList.add('d-none');
            } else {
                if(phoneLength > 0) select(msgRequiredPhone)?.classList.remove('d-none');
            }

            if (select(inputRequiredName).value.length > 2) {
                select(msgRequiredName)?.classList.add('d-none');
            } else {
                select(msgRequiredName)?.classList.remove('d-none');
            }

            select(`#finalizarcompra_step1`).setAttribute('disabled', true);
            select(`#finalizarcompra_step1`).classList.add('disabled');
            select(`#finalizarcompra_step1`).classList.add(btnRequiredInput);
        }
    }
}
